import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

const radioGroup = css`
  > label {
    margin-bottom: 20px;

    > span {
      font-weight: ${fonts.weight.regular};
      color: ${colors.black};
    }
  }
`;

export default { radioGroup };
